export default __webpack_public_path__ + "static/women5-abcaf235c5bc87e0ae6dca504a01018c.webp";